import { useState } from 'react';
import { notification } from 'antd';
import FileSaver from 'file-saver';
import { closeLoadingNotification, openLoadingNotification } from '../../utils/loadingNotification';

export default ({ children, fileName = 'download.pdf', download }) => {
  const [downloading, setDownloading] = useState(false);

  const onDownload = async () => {
    if (downloading) {
      return;
    }
    setDownloading(true);
    openLoadingNotification({ key: 'downloading', message: 'Downloading' });
    try {
      const res = await download();
      const blob = new Blob([res.data], { type: res.headers['content-type'] });
      FileSaver.saveAs(blob, fileName);
      closeLoadingNotification('downloading');
      notification.success({ key: 'download_success', message: 'Download successfully' });
    } catch (err) {
      closeLoadingNotification('downloading');
      notification.error({ key: 'download_fail', message: 'Download failed' });
    }
    setDownloading(false);
  };

  return children(onDownload, downloading);
};
